import React, { useState, useRef, useEffect } from "react";
import "./Login.css";
import { SERVER_URL, NEW_PRINT } from "../config/config";
import { useHistory } from "react-router-dom";

export default function BranchSelector({
  sessionObject,
  mainBranchSelector,
  subMenuItemsDict,
  setSubMenuItemsDict,
  setItemNamesDict,
}) {
  const [currentYear, setCurrentYear] = useState("");
  const [yearIndex, setYearIndex] = useState("");
  const [dateSelectorObj, setDateSelectorObj] = useState([]);
  const history = useHistory();

  const refStoreObject = useRef({
    branch: null,
    year: null,
    submit: null,
  });

  const branch_info = JSON.parse(sessionStorage.getItem("branch_info")).branch_info;

  const [branchInfo, setBranchInfo] = useState({
    branch_id: branch_info[0].branch_id,
    branch_name: branch_info[0].branch_name,
    branch_account_name: branch_info[0].account_name,
    branch_account_id: branch_info[0].account_id,
    branch_suffix: branch_info[0].suffix,
    branch_mobile: branch_info[0].mobile,
  });

    const fetchData = async () => {
        try {
            const res = await fetch(
                `${NEW_PRINT}/bilty/get_module_json/?client_name=${process.env.REACT_APP_CLIENT}`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ client_name: process.env.REACT_APP_CLIENT }),
                }
            );

      const result = await res.json();
      let modules = [...result.Modules];

      if (process.env.REACT_APP_CLIENT === "shubham" && sessionObject.sessionVariables.role_id !== 1) {
        modules = modules.filter((module) => module.name !== "Bill Entry");
      }

      if (process.env.REACT_APP_CLIENT === "gdala_log" && sessionObject.sessionVariables.role_id !== 1) {
        modules = modules.filter((module) => module.name !== "Station Wise Summary");
      }

      setSubMenuItemsDict({ ...result, Modules: modules });
    } catch (e) {}
  };

  const fetchItemNames = async () => {
    try {
      const res = await fetch(`${SERVER_URL}/pack_type/`);
      const result = await res.json();
      setItemNamesDict(result);
    } catch (e) {}
  };

  useEffect(() => {
    fetchData();
    fetchItemNames();
  }, []);

  useEffect(() => {
    refStoreObject.current.branch?.focus();
  }, []);

  useEffect(() => {
    let selectorObj = [];

    const currDate = new Date();
    let currMonth = currDate.getMonth() + 1;
    let currYear =
      currDate.getFullYear().toString().substring(2) - (currMonth < 4);

    if (process.env.REACT_APP_CLIENT === "bgtc") {
      let nextYear = Number(currYear) + 1;
      const value = currYear + "-" + nextYear;

      selectorObj.push({
        value,
        label: `01/04/20${currYear} - 31/03/20${nextYear}`,
      });

      setCurrentYear(value);
      setYearIndex(value);
      setDateSelectorObj(selectorObj);
      return;
    }

    let yearRange = 4;
    let isCurrentYearSet = false;

    if (currYear == "21") {
      selectorObj.push({
        value: "22-23",
        label: "01/04/2022 - 31/03/2023",
      });
    }

    for (let i = 0; i < yearRange; i++) {
      let temp1 = currYear - i;
      let temp2 = temp1 + 1;

      let tempObj = {
        value: temp1 + "-" + temp2,
        label: "01/04/20" + temp1 + " - 31/03/20" + temp2,
      };

      if (!isCurrentYearSet) {
        isCurrentYearSet = true;
        setCurrentYear(temp1 + "-" + temp2);
        setYearIndex(temp1 + "-" + temp2);
      }

      selectorObj.push(tempObj);
    }

    setDateSelectorObj(selectorObj);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    sessionObject.saveSessionVariableByObject({
      ...branchInfo,
      financial_year: yearIndex,
      financial_year_for_fetch: yearIndex,
    });

    history.push("/");
  };

  const handleBackToLogin = () => {
    try {
      if (sessionObject && typeof sessionObject.saveSessionVariableByField === "function") {
        sessionObject.saveSessionVariableByField("access_token", "");
      } else {
        sessionStorage.removeItem("access_token");
      }
    } catch (e) {
      sessionStorage.removeItem("access_token");
    }


    history.push("/");
  };

  // --------------------  STYLES  -----------------------

  const wrapper = {
    height: "calc(100vh - 80px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f6fa",
    fontFamily: "Inter, sans-serif",
    padding: "20px",
  };

  const card = {
    width: "320px",
    background: "#fff",
    padding: "30px 26px",
    borderRadius: "12px",
    border: "1px solid #e3e6ea",
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
    textAlign: "center",
    position: "relative",
  };

  const backBtn = {
    position: "absolute",
    left: "14px",
    top: "12px",
    background: "transparent",
    border: "none",
    color: "#43507d",
    fontSize: "14px",
    cursor: "pointer",
    padding: "6px 8px",
    borderRadius: "6px",
  };

  const icon = {
    fontSize: "48px",
    marginBottom: "8px",
  };

  const title = {
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: "3px",
  };

  const subTitle = {
    fontSize: "13px",
    color: "#666",
    marginBottom: "25px",
  };

  const selectBox = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    background: "#fbfbfd",
    marginBottom: "30px",
    fontSize: "16px",
    cursor: "pointer",
    outline: "none",
  };

  const submitBtn = {
    width: "100%",
    background: "#43507d",
    padding: "12px 0",
    borderRadius: "8px",
    border: "none",
    color: "white",
    fontSize: "16px",
    fontWeight: 600,
    cursor: "pointer",
    outline: "none",
    transition: "0.15s ease",
  };


  return (
    <div style={wrapper}>
      <div style={card}>
        <button
          type="button"
          style={backBtn}
          onClick={handleBackToLogin}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.currentTarget.click();
          }}
          aria-label="Back to login"
        >
          ← Back to Login
        </button>

        <div style={icon}>🏦</div>

        <div style={title}>Select Branch</div>
        <div style={subTitle}>Choose your branch and year</div>

        <form onSubmit={handleSubmit}>
          <select
            style={selectBox}
            ref={(a) => (refStoreObject.current.branch = a)}
            onChange={(e) => {
              const id = e.target.value;

              for (let i = 0; i < branch_info.length; i++) {
                if (branch_info[i].branch_id == id) {
                  setBranchInfo({
                    branch_id: id,
                    branch_name: branch_info[i].branch_name,
                    branch_account_name: branch_info[i].account_name,
                    branch_account_id: branch_info[i].account_id,
                    branch_suffix: branch_info[i].suffix,
                    branch_mobile: branch_info[i].mobile,
                  });
                }
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                refStoreObject.current.year?.focus();
              }
            }}
            onFocus={(e) => {
              e.target.style.border = "1px solid #43507d";
              e.target.style.boxShadow = "0 0 0 2px rgba(67,80,125,0.20)";
            }}
            onBlur={(e) => {
              e.target.style.border = "1px solid #d1d5db";
              e.target.style.boxShadow = "none";
            }}
          >
            {branch_info.map((b) => (
              <option value={b.branch_id} key={b.branch_id}>
                {b.branch_name}
              </option>
            ))}
          </select>

          <select
            style={selectBox}
            value={yearIndex}
            ref={(a) => (refStoreObject.current.year = a)}
            onChange={(e) => setYearIndex(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                refStoreObject.current.submit?.focus();
              }
            }}
            onFocus={(e) => {
              e.target.style.border = "1px solid #43507d";
              e.target.style.boxShadow = "0 0 0 2px rgba(67,80,125,0.20)";
            }}
            onBlur={(e) => {
              e.target.style.border = "1px solid #d1d5db";
              e.target.style.boxShadow = "none";
            }}
          >
            {dateSelectorObj.map((y) => (
              <option value={y.value} key={y.value}>
                {y.label}
              </option>
            ))}
          </select>

          <button
            type="submit"
            style={submitBtn}
            ref={(a) => (refStoreObject.current.submit = a)}
            onMouseEnter={(e) => (e.target.style.background = "#363f63")}
            onMouseLeave={(e) => (e.target.style.background = "#43507d")}
            onFocus={(e) => {
              e.target.style.boxShadow = "0 0 0 2px rgba(67,80,125,0.25)";
            }}
            onBlur={(e) => {
              e.target.style.boxShadow = "none";
            }}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
